<template>
  <a :href="github.livelink" target="_blank" class="github-card">
    <!-- <div class="card" :github='github'>
      <div class="card-content">
        <span class="words is-size-3 is-size-4-mobile has-text-weight-bold">{{github.id}} - {{github.name}}</span>
        <div>{{github.description}}</div>
      </div>
    </div> -->
  <article class="media card" :github='github'>
    <figure class="media-left">
      <p class="image is-64x64">
        <!-- <img src="https://news.efinancialcareers.com/binaries/content/gallery/efinancial-careers/articles/2019/04/github.jpg" alt="Dots"/> -->
        <img src="../assets/SpectroPicDots.png" alt="Dots"/>
      </p>
    </figure>
    <div class="media-content">
      <div class="content">
        <p>
          <a :href="github.url" target="_blank"><small>@TuftsANTI on Github Link: </small><strong>{{github.name}}</strong> <i><img id="external-link" src="../assets/external-link-symbol.png"/></i></a>
          <br>
          {{github.description}}
        </p>
      </div>
    </div>
    <figure class="media-right is-hidden-mobile">
      <p class="languages">Language</p>
      <p class="type">
        {{github.type}}
      </p>
  </figure>
  </article>
  </a>
</template>

<script>
export default {
  props: [
    'github'
  ]
}
</script>

<style lang="scss" scoped>
//   .github-card {
//       display: flex;
//       flex-wrap: wrap;
//       width: 40%;
//   }
  .card {
    padding: 0;
    height: 7rem;
    border: 2px solid black;
    border-radius: 25px;
    margin: 20px;
    background-color: ghostwhite;
  }
  // .card-content {
  //   display: flex;
  //   // padding-top: 50px;
  //   position: absolute;
  //   color: #FFF;
  //   background-color: rgba(0, 0, 0, 0.25);
  //   // top: 0;
  //   right: 0;
  //   padding: 10px;
  //   height: 100%;
  //   border: 2px solid black;
  //   border-radius: 25px;
  //   width: 30%;
  // }
  .image > img {
    position: absolute;
    left: 1em;
    top: 30%;
  }
  #external-link {
    width: 12px;
    height: auto;
    color: blue;
  }
  .type {
    position: absolute;
    right: 2em;
    top: 40%;
    color: red;
  }
  .languages {
    position: absolute;
    right: 2em;
    top: 20%;
  }
  @media (max-width: 500px) {
    .image {
      position: absolute;
      max-width: 32px;
      top: 20%;
      left: 0;
    }
    .content {
      font-size: 0.8em;
      position: absolute;
      right: 0;
      width: 75%;
      padding: 5px;
    }
  }
//     span {
//       font-size: 60px;
//       text-align: center;
//       width: 100%;
//       position: absolute;
//       bottom: 0rem;
//       right: 0;
//     }
//     h2 {
//       // margin-top: 10px;
//       // height: 100%;
//       // width: 40%
//     }
// }
//   .github-number {
//     // background-color: ghostwhite;
//     color: ghostwhite;
//     font-size: 2em;
//     padding: 0 10px;
//     position: absolute;
//     top: 0;
//     // left: 0;
//   }
//   .words {
//     color: ghostwhite;
//     // font-size: 1em;
//     padding: 0 20px;
//     text-align: center;
//     width: 30%;
//     margin: auto;
//   }
//   @media (max-width: 500px) {
//   .words {
//     font-size: 2em;
//     padding: 0 20px;
//     width: 50%;
//     position: absolute;
//     top: .5rem;
//     right: 0rem;
//   }
//   }
</style>